import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { History, createBrowserHistory } from 'history';
import { reducers } from './';
import { firebaseReducer } from 'react-redux-firebase';
import authReducer from './../reducers/authReducer';
import profileReducer from './../reducers/profileReducer';
import modalReducer from './../reducers/modalReducer';
import modalCallbackReducer from './../reducers/modalCallbackReducer';
import modalSalesReducer from './../reducers/modalSalesReducer';
import modalPolicyReducer from './../reducers/modalPolicyReducer';
import cameraReducer from './../reducers/cameraReducer';
import navigationReducer from './../reducers/navigationReducer';
import fullscreenReducer from './../reducers/fullscreenReducer';
import sspReducer from './../reducers/sspReducer';
import cartReducer from './../reducers/cartReducer';
import claimSubmitReducer from './../reducers/claimSubmitReducer';
import { getFirebase } from "react-redux-firebase";
import { SIGNOUT_SUCCESS } from '../constants/constants';
import salesReducer from '../reducers/salesReducer';
import selfInspectReducer from '../reducers/selfInspectReducer';
import templateReducer from '../reducers/templateReducer';
import claimsHistoryReducer from '../reducers/claimsHistoryReducer';
import fanclubReducer from '../reducers/fanclubReducer';
import lifePolicyReducer from '../reducers/lifePolicyReducer';
import externalReducer from '../reducers/externalReducer';

function configureStore(history: History) {
    const middleware = [
        thunk.withExtraArgument({ getFirebase }),
        routerMiddleware(history)
    ];

    const rootReducer = (state, action) => {
        if (action.type === SIGNOUT_SUCCESS) {
            state = undefined
        }

        return appReducer(state, action)
    } 

    const appReducer = combineReducers({
        ...reducers,
        router: connectRouter(history),
        firebase: firebaseReducer,
        auth: authReducer,
        modal: modalReducer,
        modalCallback: modalCallbackReducer,
        modalSales: modalSalesReducer,
        modalPolicy : modalPolicyReducer,
        fullscreen: fullscreenReducer,
        profile: profileReducer,
        camera: cameraReducer,
        navigation: navigationReducer,
        claimSubmit: claimSubmitReducer,
        ssp: sspReducer,
        sales: salesReducer,
        cart: cartReducer,
        selfInspect: selfInspectReducer,
        claimsHistory: claimsHistoryReducer,
        TemplateData: templateReducer,
        fanclub: fanclubReducer,
        lifePolicy: lifePolicyReducer,
        external: externalReducer,
    });

    const enhancers = [];

    const persistConfig = {
        key: 'root',
        storage: storage,
        stateReconciler: autoMergeLevel2,
        blacklist: ['fullscreen'],
    };

    const persistedReducers = persistReducer(persistConfig, rootReducer);

    return createStore(
        persistedReducers,
        compose(applyMiddleware(...middleware), ...enhancers)
    );
}

// Create browser history to use in the Redux store
var base = document.getElementsByTagName('base')[0];
var baseUrl = "/";
if (base !== undefined) {
    baseUrl = base.getAttribute('href') as string;
}
export const history = createBrowserHistory({ basename: baseUrl });

export const store = configureStore(history);
export const persistor = persistStore(store);

export default store;